// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import { rawRequest } from "@insite/client-framework/Services/ApiService";
import downloadFile from "@store/Framework/Common/Utilities/downloadFile";

const documentUrl = "api/v1/custom/documents";

interface GetProductDataSheetParameters {
    productNumber: string;
    plant?: string;
}

interface GetUNCertificatePdfParameters {
    unCertificateNumber: string;
    plant?: string;
}

interface GetInvoicePdfParameters {
    prefix?: string;
    invoiceNumber: string;
    isShipment: boolean;
}

interface GetOrderHistoryParameters {
    prefix?: string;
    parameter?: string;
}

interface GetOrderInvoiceParameters {
    prefix?: string;
    parameter?: string;
}

interface GetShippingDocumentsParameters {
    shipmentNumber: string;
}

interface GetOrderAcknowledgementParameters {
    acknowledgementNumber: string;
}

interface GetTrailerOverviewParameters {
    parameter: string;
}

export const getProductDataSheet = async ({ productNumber, plant }: GetProductDataSheetParameters) => {
    const url = `${documentUrl}/specsheets/${productNumber}/${plant}`;
    const document = await getDocument(url);
    const documentName = `Datasheet-${productNumber}`;

    downloadFile(document.data, documentName);
};

export const getUNCertificatePdf = async ({ unCertificateNumber, plant }: GetUNCertificatePdfParameters) => {
    const url = `${documentUrl}/uncertificate/${unCertificateNumber}/${plant}`;
    const document = await getDocument(url);
    const documentName = `Certificate-${unCertificateNumber}`;

    downloadFile(document.data, documentName);
};

export const getInvoicePdf = async ({ invoiceNumber, isShipment }: GetInvoicePdfParameters) => {
    const url = `${documentUrl}/invoices/${invoiceNumber}/${isShipment}`;
    const document = await getDocument(url);
    const documentName = `Invoice-${invoiceNumber}`;

    downloadFile(document.data, documentName);
};

export const getOrderHistory = async ({ parameter }: GetOrderHistoryParameters) => {
    const url = `api/v1/custom/orders/export/${parameter}`;
    const document = await getDocument(url);
    const documentName = document.name;
    downloadFile(document.data, documentName);
};

export const getInvoiceHistory = async ({ parameter }: GetOrderInvoiceParameters) => {
    const url = `api/v1/custom/invoices/export/${parameter}`;
    const document = await getDocument(url);
    const documentName = document.name;
    downloadFile(document.data, documentName);
};

export const getShippingDocuments = async ({ shipmentNumber }: GetShippingDocumentsParameters) => {
    const url = `${documentUrl}/shippingDocuments/${shipmentNumber}`;
    const document = await getDocument(url);
    const documentName = `Shipment-${shipmentNumber}`;

    downloadFile(document.data, documentName);
};

export const getDocumentAcknowledgement = async ({ acknowledgementNumber }: GetOrderAcknowledgementParameters) => {
    const url = `${documentUrl}/acknowledgements/${acknowledgementNumber}`;
    const document = await getDocument(url);
    const documentName = `Acknowledgement-${acknowledgementNumber}`;

    downloadFile(document.data, documentName);
};

export const getExportPriceList = async () => {
    const url = "api/v1/custom/products/export-pricelist";
    const document = await getDocument(url);
    const documentName = document.name;

    downloadFile(document.data, documentName);
};

export const getTrailerOverview = async ({ parameter }: GetTrailerOverviewParameters) => {
    const url = `api/v1/custom/droptrailer/export/${parameter}`;
    const document = await getDocument(url);
    const documentName = document.name;

    downloadFile(document.data, documentName);
};

const getDocument = async (url: string): Promise<any> => {
    const request = await blobRequest(url, "get");
    const blob = await request.blob();
    const fileName = request.headers.get("Content-Disposition");
    const returnObj = {
        data: blob,
        name: fileName?.match(/(?<=\")(.*?)(?=\")/gm),
    };
    return returnObj;
};

const blobRequest = (
    endpoint: string,
    method: string,
    headers: Dictionary<string> = { "X-Requested-With": "XMLHttpRequest" },
    body?: string | FormData,
    isStatusOkay?: (status: number) => boolean,
    cache: RequestInit["cache"] = "no-cache",
): Promise<Response> => {
    return rawRequest(endpoint, method, headers, body, isStatusOkay, cache);
};
